import classNames from 'classnames';
import type { BEMBlockCreator, BEMClassCreator } from './types';

const createBEMClasses: BEMClassCreator = (block, element, modifiers) => {
    const classBody = element ? `${block}__${element}` : block;

    return Object.entries(modifiers ?? {}).reduce(
        (prev, [modifier, condition]) => classNames(prev, { [`${classBody}--${modifier}`]: condition }),
        classBody,
    );
};

export const BEMBlock: BEMBlockCreator = (block, modifiers) => [
    createBEMClasses(block, undefined, modifiers),
    (element, elementModifiers) => createBEMClasses(block, element, elementModifiers),
];
